import { render, staticRenderFns } from "./examineModel.vue?vue&type=template&id=9945f7a0"
import script from "./examineModel.vue?vue&type=script&lang=js"
export * from "./examineModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9945f7a0')) {
      api.createRecord('9945f7a0', component.options)
    } else {
      api.reload('9945f7a0', component.options)
    }
    module.hot.accept("./examineModel.vue?vue&type=template&id=9945f7a0", function () {
      api.rerender('9945f7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/examineForm/examineModel.vue"
export default component.exports